/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityType {
    LOAN = 'LOAN',
    PREFERENCE_SHARE = 'PREFERENCE_SHARE',
    TRACKING_SHARE = 'TRACKING_SHARE',
    PARTNERSHIP_UNIT = 'PARTNERSHIP_UNIT',
    OPTIONS = 'OPTIONS',
    ORDINARY_SHARE = 'ORDINARY_SHARE',
    VIRTUAL_EQUITY = 'VIRTUAL_EQUITY',
    OTHER = 'OTHER',
    WARRANT = 'WARRANT',
    OTHER_EQUITY = 'OTHER_EQUITY',
    BOND = 'BOND',
    DEFERRED_SHARE = 'DEFERRED_SHARE',
}
